module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Save-b64f6328f45ab3d014130824ae7d55b2.svg";